import {
  GET_USER_CITATIONS_REQUEST,
  GET_USER_CITATIONS_SUCCESS,
  GET_USER_CITATIONS_ERROR,
  RESET_USER_CITATIONS,
} from '../actions/types';

const defaultState = {
  citations: {},
  isLoading: false,
  hasData: false,
};

/**
 * User's permit object reducer logic.
 * @param {Object} state - The state for this reducer in Redux.
 * @param {Object} action - The action which details what to do & what state to update.
 * @returns {Object} - Newly created state object.
 */
export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_USER_CITATIONS_REQUEST:
      return { ...state, isLoading: true };
    case GET_USER_CITATIONS_SUCCESS:
      return {
        ...state, citations: action.payload, isLoading: false, hasData: true,
      };
    case GET_USER_CITATIONS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case RESET_USER_CITATIONS:
      return defaultState;
    default:
      return state;
  }
};
